var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStackedBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "17 7 71 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42.168,27.092c0-.366-.297-.663-.663-.663h-6.628c-.366,0-.663.297-.663.663v8.393h7.953v-8.393Z",
    fill: "#4a5a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.215,37.485v7.513c0,.366.297.663.663.663h6.628c.366,0,.663-.297.663-.663v-7.513h-7.953Z",
    fill: "#f3c144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.083,12.511c0-.366-.297-.663-.663-.663h-6.628c-.366,0-.663.297-.663.663v20.424h7.953V12.511Z",
    fill: "#4a5a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.13,34.936v10.062c0,.366.297.663.663.663h6.628c.366,0,.663-.297.663-.663v-10.062h-7.953Z",
    fill: "#69ab5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.012,19.139c0-.366-.297-.663-.663-.663h-6.628c-.366,0-.663.297-.663.663v9.141h7.953v-9.141Z",
    fill: "#4a5a63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.059,30.28v14.718c0,.366.297.663.663.663h6.628c.366,0,.663-.297.663-.663v-14.718h-7.953Z",
    fill: "#4d95eb"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBar);
export default __webpack_public_path__ + "static/media/stacked-bar.ba5c9114.svg";
export { ForwardRef as ReactComponent };